import React from 'react';

function BreakPatternErrorMessage({ message = '' }) {
  if (!message) return null;

  return <small className="error-message">{message}</small>;
}

export default BreakPatternErrorMessage;
